/** Shared offsets for fixed navbar and main column (see LoggedInPage #main marginLeft). */
export const DSYS_NAVBAR_HEIGHT = '52px';
export const DSYS_MAIN_OFFSET_LEFT = '56px';

/** Top inset on Layout.Header; overlaps Layout.Container padding so flow height excludes this. */
export const DSYS_CHROME_TOP_INSET_PX = 32;

/** Until ResizeObserver runs, reserve flow space and sticky offset (title + tabs, no double top inset). */
export const DSYS_FIXED_CHROME_FLOW_FALLBACK = '120px';
export const DSYS_STICKY_OFFSET_TOP_FALLBACK = `calc(${DSYS_NAVBAR_HEIGHT} + 152px)`;

/** Fixed Layout.Header — above page-scroll table edge shadows (z-index 3). */
export const DSYS_FIXED_CHROME_Z_INDEX = 4;

export const layoutRootCssVars = {
  '--dsys-navbar-height': DSYS_NAVBAR_HEIGHT,
  '--dsys-main-offset-left': DSYS_MAIN_OFFSET_LEFT,
  '--dsys-fixed-chrome-height': DSYS_FIXED_CHROME_FLOW_FALLBACK,
  '--dsys-sticky-offset-top': DSYS_STICKY_OFFSET_TOP_FALLBACK,
  '--dsys-fixed-chrome-z-index': String(DSYS_FIXED_CHROME_Z_INDEX),
} as const;

/**
 * Layout.Page spacing, shared by every page on it so titles, rails and content
 * land in the same spot page to page. Change these, not page-level padding.
 */
export const DSYS_PAGE_PADDING_TOP_PX = 32;
/** Page sides: the header and the content panes. */
export const DSYS_PAGE_GUTTER_PX = 32;
/** How far past the gutter `lean` panes (News) lean content toward the middle. */
export const DSYS_CONTENT_MAX_OFFSET_PX = 160;
export const DSYS_PAGE_HEADER_PADDING_BOTTOM_PX = 16;
/** Rail rows' own text inset (WorkstreamTree, WorkstreamsSearch rows). */
export const DSYS_RAIL_ROW_INSET_PX = 8;
/** Derived so rail row text lines up with the header title at the gutter. */
export const DSYS_RAIL_INSET_LEFT_PX = DSYS_PAGE_GUTTER_PX - DSYS_RAIL_ROW_INSET_PX;
export const DSYS_RAIL_INSET_RIGHT_PX = 8;
/** Rail rows (and their chevrons) on narrow screens: a finger-sized target. */
export const DSYS_TOUCH_TARGET_PX = 44;
export const DSYS_RAIL_WIDTH = {min: 240, max: 560} as const;
/**
 * Rail sizes, each with its own default and saved width: `nav` for rails of
 * short names (Workstreams), `feed` for thumbnails + titles (News).
 */
export const DSYS_RAIL_DEFAULT_WIDTH = {nav: 320, feed: 400} as const;
export type DsysRailSize = keyof typeof DSYS_RAIL_DEFAULT_WIDTH;
